import React, { useState, useEffect } from "react";
import axios from "axios";
import API_BASE_URL from "../config";
import { Bar } from "react-chartjs-2";
import "chart.js/auto";
// import "./EmployeePerformance.css";

const EmployeePerformance = ({ employee }) => {
  const [performance, setPerformance] = useState(null);

  useEffect(() => {
    const fetchPerformance = async () => {
      try {
        const res = await axios.get(
          `${API_BASE_URL}/api/performance/${employee._id}`
        );

        // 🔹 Normalize status keys to lowercase for consistency
        const data = {
          completed: res.data.completed || 0,
          inProgress: res.data.inProgress || 0,
          pending: res.data.pending || 0,
          percentage: res.data.percentage || 0,
        };

        setPerformance(data);
      } catch (err) {
        console.error("Error fetching performance:", err);
      }
    };

    fetchPerformance();
  }, [employee]);

  if (!performance) {
    return (
      <div className="ep-loading">
        <p>Loading performance...</p>
      </div>
    );
  }

  const chartData = {
    labels: ["Completed", "In Progress", "Pending"],
    datasets: [
      {
        label: "Tasks",
        data: [
          performance.completed,
          performance.inProgress,
          performance.pending,
        ],
        backgroundColor: ["#4caf50", "#ff9800", "#f44336"],
      },
    ],
  };

  return (
    <div className="ep-container">
      <h3>Employee Performance</h3>

      <div className="ep-stats">
        <p>
          <strong>Completed:</strong> {performance.completed}
        </p>
        <p>
          <strong>In Progress:</strong> {performance.inProgress}
        </p>
        <p>
          <strong>Pending:</strong> {performance.pending}
        </p>
        <p>
          <strong>Overall %:</strong> {performance.percentage}%
        </p>
      </div>

      <div className="ep-chart">
        <Bar data={chartData} />
      </div>
    </div>
  );
};

export default EmployeePerformance;
